import React, { useEffect, useState } from 'react'
import CustomSelector from '../lists/TownSelect'
import { Link, useNavigate } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css'
import './Header.css'
import logo from '../../assets/Header/logo.png'
import icon_location from '../../assets/Header/icon_location.png'
import menu from '../../assets/Main/menu_mob.svg'


function Header({
    hideElements = false,
    menuItems,
    rightContent,
    showLocation = true,
    mobileMenuItems,
    showMobileButton = false,  // новый пропс
    onMobileButtonClick        // новый пропс
  }) {

  const navigate = useNavigate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)    // для мобильной версии
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth <= 1024)

  // отслеживаем изменение размера окна
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth <= 1024)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // дефолтные значения
  const defaultMenuItems = [
    { label: 'О платформе', to: '/about' },
    { label: 'Каталог исполнителей', to: '/customer_all_specialists' },
  ]
  
  const defaultMobileMenuItems = [
    { label: 'О платформе', to: '/about' },
    { label: 'Каталог исполнителей', to: '/customer_all_specialists' },
  ]
  
  const defaultRightContent = (
    <button className="btn-blue" onClick={() => navigate('/enter')}>
      Войти
    </button>
  )

  const items = menuItems || defaultMenuItems
  const mobileItems = mobileMenuItems || defaultMobileMenuItems
  const contentOnRight = rightContent || defaultRightContent

  // меню для мобилки
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
  
  // закрываем меню при переходе по ссылке
  const handleMenuItemClick = () => {
    setIsMenuOpen(false)
  }

  // определяем, куда вести по клику на логотип
  const getHomePath = () => {
    const token = localStorage.getItem('accessToken');
    const role = localStorage.getItem('userRole');

    if (!token) {
      return '/';                    // не авторизован 
    }

    if (role === 'EXECUTOR') {
      return '/main_executor';
    }

    if (role === 'CUSTOMER') {
      return '/main_customer';
    }

    return '/';
  };

  const homePath = getHomePath();

  const handleLogoClick = (event) => {
    if (window.location.pathname === homePath) {
      event.preventDefault();
      window.location.assign(homePath);
    }
  };

  return (
    <div className={`headerContainer ${hideElements ? 'headerContainer--centered' : ''}`}>
      {/* ЛЕВАЯ ЧАСТЬ: лого и пункты меню */}
      <div className='header-left d-flex align-items-center'>
        <Link
          to={homePath}
          className="header-logo-link"
          onClick={handleLogoClick}
          aria-label="Перейти на главную страницу"
        >
          <img src={logo} alt="logo" className="header-logo"/>
        </Link>

        {/* декстопные пункты меню */}
        <div className='header-items'>
          {items.map((item, i) => (
            item.to ? (
              <Link key={i} to={item.to} className="text-decoration-none text-dark">
                {item.label}
              </Link>
            ) : (
              <a key={i} className="text-decoration-none text-dark" onClick={item.onClick}>
                {item.label}
              </a>
            )
          ))}
        </div>
      </div>

      {/* ПРАВАЯ ЧАСТЬ: локация и кнопка войти */}
      {!hideElements && (
        <div className='header-right d-flex align-items-center'>
          {/* локация */}
          {showLocation && !isMobile && !isTablet && (
            <div className='location-wrapper d-md-flex align-items-center' style={{marginRight:'30px'}}>
              <img src={icon_location} alt='location' className='location-icon'/>
              <CustomSelector className='town-select'/>
            </div>
          )}

          {/* кнопка войти/кнопка юзера */}
          {contentOnRight}

          {/* мобильная кнопка меню */}
          <button className='mobile-menu-btn' onClick={toggleMenu}>
            <img src={menu} alt='Меню' />
          </button>
        </div>
      )}

      {/* МОБИЛЬНОЕ ВЫПАДАЮЩЕЕ МЕНЮ */}
      {isMenuOpen && (
        <div className="mobile-dropdown-menu">
          {mobileItems.map((item, index) => (
            <React.Fragment key={index}>
              {item.to ? (
                <Link 
                  to={item.to} 
                  className="mobile-menu-item"
                  onClick={handleMenuItemClick}
                >
                  {item.label}
                </Link>
              ) : (
                <a 
                  className="mobile-menu-item" 
                  onClick={() => {
                    if (item.onClick) item.onClick()
                    handleMenuItemClick()
                  }}
                >
                  {item.label}
                </a>
              )}
            </React.Fragment>
          ))}
          
          {/* Кнопка в мобильном меню (если showMobileButton = true) */}
          {showMobileButton && (
            <>
              {mobileItems.length > 0 && <div className="menu-divider" />}
              <button 
                className="btn-blue mobile-menu-button" 
                onClick={() => {
                  if (onMobileButtonClick) onMobileButtonClick()
                  handleMenuItemClick()
                }}
              >
                Создать заказ
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Header
